import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
//Limitless imports

// Set the default state values for each context
const SettingsDrawerContext = /*#__PURE__*/createContext({});
const useSettingsDrawerHook = () => {
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
  const toggleSettingsDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };
  return {
    isDrawerOpen,
    toggleSettingsDrawer
  };
};
export const SettingsDrawerContextProvider = ({
  children
}) => {
  const settingsDrawer = useSettingsDrawerHook();
  return /*#__PURE__*/React.createElement(SettingsDrawerContext.Provider, {
    value: settingsDrawer
  }, children);
};
export const useSettingsDrawer = () => {
  return useContext(SettingsDrawerContext);
};
SettingsDrawerContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};